import React from 'react';
import Contact1 from './1';
import Contact2 from './2';

function Contact() {
  return (
    <>
      <Contact1 />
      <Contact2 />
    </>
  );
}

export default Contact;
